import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Cubre Blue Cross Blue Shield SAINT® TMS?",
    answer:
      "La cobertura varía según el plan de Blue Cross Blue Shield. Es posible que esté cubierto; verificamos sus beneficios sin costo. No estamos afiliados ni respaldados por Blue Cross Blue Shield. La cobertura varía según el plan. [[Verifique sus beneficios|/es/saint-tms-insurance-coverage]] o llame al 954-827-9793.",
  },
  {
    question: "¿SAINT® TMS está dentro de la red de Blue Cross Blue Shield?",
    answer:
      "No afirmamos estar dentro de la red de ninguna aseguradora. La cobertura de SAINT® TMS varía según el plan. Verificamos sus beneficios sin costo. No estamos afiliados ni respaldados por Blue Cross Blue Shield.",
  },
];

export const esBcbsSaint = makeEsArticle({
  slug: "blue-cross-blue-shield-saint-tms",
  title: "SAINT® TMS y Blue Cross Blue Shield | Neuro Wellness",
  description:
    "Cobertura de SAINT® TMS con Blue Cross Blue Shield. No estamos afiliados ni respaldados por Blue Cross Blue Shield. La cobertura varía según el plan.",
  h1: "SAINT® TMS y Blue Cross Blue Shield",
  breadcrumbLabel: "SAINT® y Blue Cross Blue Shield",
  shortAnswer:
    "La cobertura de SAINT® TMS con Blue Cross Blue Shield varía según el plan. Es posible que esté cubierto; verificamos sus beneficios sin costo. No estamos afiliados ni respaldados por Blue Cross Blue Shield. La cobertura varía según el plan. SAINT® está autorizado por la FDA (K220177) para adultos cuya depresión no ha mejorado con antidepresivos. [[Verifique sus beneficios|/es/saint-tms-insurance-coverage]] o llame al 954-827-9793.",
  keyTakeaways: [
    "La cobertura de SAINT® con Blue Cross Blue Shield varía según el plan.",
    "Es posible que esté cubierto.",
    "Verificamos sus beneficios sin costo.",
    "No estamos afiliados ni respaldados por Blue Cross Blue Shield.",
    "SAINT® está autorizado por la FDA (K220177).",
  ],
  sections: [
    {
      heading: "Cobertura de Blue Cross Blue Shield",
      paragraphs: [
        "La cobertura de SAINT® TMS con Blue Cross Blue Shield varía según el plan. Es posible que esté cubierto. Verificamos sus beneficios sin costo. No estamos afiliados ni respaldados por Blue Cross Blue Shield; la cobertura varía según el plan.",
      ],
    },
    {
      heading: "Sobre SAINT®",
      paragraphs: [
        "SAINT® está autorizado por la FDA (K220177) para adultos con trastorno depresivo mayor que no han mejorado con antidepresivos. No está indicado para ansiedad, trastorno bipolar, TEPT u otras condiciones. [[Verifique sus beneficios|/es/saint-tms-insurance-coverage]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
